import React from "react";

const ProductSubscriptionSkeleton = ({ rows = 10 }) => {
  const skeletonRows = Array.from({ length: rows });

  const baseSkeleton =
    "inline-block rounded-[4px] " +
    "bg-[linear-gradient(90deg,#f5f5f5_0%,#e6e6e6_50%,#f5f5f5_100%)] " +
    "[background-size:200%_100%] " +
    "animate-[ps-skeleton-shimmer_1.2s_ease-in-out_infinite]";

  return (
    <>
      <style>{`
        @keyframes ps-skeleton-shimmer {
          0% {
            background-position: -200px 0;
          }
          100% {
            background-position: calc(200px + 100%) 0;
          }
        }
      `}</style>

      {skeletonRows.map((_, index) => (
        <tr key={index} className="ps-skeleton-row">
          {/* Checkbox */}
          <td
            data-col="checkbox"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div
              className={`${baseSkeleton} w-4 h-4 rounded-[3px] align-middle`}
            />
          </td>

          {/* Image */}
          <td
            data-col="image"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div
              className={`${baseSkeleton} w-10 h-10 rounded-md align-middle`}
            />
          </td>

          {/* SKU + "Show variants" line */}
          <td
            data-col="sku"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className="flex flex-col gap-1">
              <div className={`${baseSkeleton} h-[10px] w-[70%]`} />
              <div className={`${baseSkeleton} h-[10px] w-[45%]`} />
            </div>
          </td>

          {/* Name */}
          <td
            data-col="name"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className="flex flex-col gap-1">
              <div className={`${baseSkeleton} h-[10px] w-[70%]`} />
            </div>
          </td>

          {/* Category */}
          <td
            data-col="category"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className="flex flex-col gap-1">
              <div className={`${baseSkeleton} h-[10px] w-[70%]`} />
            </div>
          </td>

          {/* Selling Price */}
          <td
            data-col="sp"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className={`${baseSkeleton} w-12 h-[10px]`} />
          </td>

          {/* Shopify Sync */}
          <td
            data-col="shopify"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className={`${baseSkeleton} w-12 h-[10px]`} />
          </td>

          {/* Amazon Sync */}
          <td
            data-col="amazon"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className={`${baseSkeleton} w-12 h-[10px]`} />
          </td>

          {/* Subscribe On */}
          <td
            data-col="created"
            className="py-2 px-3 align-middle h-16 box-border"
          >
            <div className={`${baseSkeleton} w-[120px] h-[10px]`} />
          </td>
        </tr>
      ))}
    </>
  );
};

export default ProductSubscriptionSkeleton;